import React, { useEffect, useState } from "react";
// import config from '../coreFIles/config'
import Header from "../directives/header";
import Footer from "../directives/footer";
import Sidebar from "../directives/sidebar";
import config from "../coreFIles/config";
import ReactDatatable from "@ashvin27/react-datatable";
import { deletecityAction, getAllcitieslistAction } from "../Action/action";
import Swal from "sweetalert2";
import moment from "moment";
import {CSVLink} from 'react-csv';

const Cities = () => {
  const [getcitylist, setCityList] = useState({});
    const [CSVData, setCSVData] = useState([]);

  useEffect(() => {
    getcities();
  }, []);

  const getcities = async () => {
    let res = await getAllcitieslistAction();
    if (res.success) {
      if(res.data.length > 0){
        let csvData = res.data;
        let csvAllData = [];
        for (let i = 0; i < csvData.length; i++) {
            if(i == 0){
              csvAllData[i] = ['Name'];
            }
            csvAllData[i+1] = [csvData[i].title];
        }
        setCSVData(csvAllData);
      }
      setCityList(res.data);
    }
  };

  const columns = [
    {
      key: "Sno.",
      text: "Sno.",
      cell: (row, index) => index + 1,
    },

    {
      key: "title",
      text: "Name",
      cell: (item) => {
        return `${item.title}`;
      },
    },
    {
      key: "is_active",
      text: "Status",
      cell: (item) => {
       return (
			 <>
					{item.is_active == 1 ? 'Active' : 'In-active'}
			 </>
           );
      },
    },

    {
      key: "action",
      text: "Action",
      cell: (item) => {
        return (
          <>
            <a
              href={`${config.baseUrl}editcity/${item.id}`}
              className="btn btn-sm btn-primary"
              id="editbtnid"
            >
              Edit
            </a>
           &nbsp;
            <button
              type="button"
              className="btn btn-sm btn-primary"
              id="editbtnid"
              onClick={() => deletecity(item.id)}
            >
              Delete
            </button>
            &nbsp;
          </>
        );
      },
    },
  ];

  const configForTable = {
    page_size: 10,
    length_menu: [10, 20, 50],
    show_filter: true,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
  };

  const deletecity = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete this Category!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Deleted it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await deletecityAction({ id: id });
        if (res.success) {
          getcities();
          // toast.success(res.msg);
          Swal.fire("Deleted!", res.msg, "success");
        } else {
          Swal.fire("Failed!", res.msg, "error");
          // toast.error(res.msg);
        }
      }
    });
  };

  return (
    <>
      <div class="wrapper">
        {/* <div id="loader"></div> */}
        <Header />
        <Sidebar />
        <div className="content-wrapper">
          <div className="container-full">
            {/* Main content */}
            <div className="content-header">
              <div className="d-flex align-items-center">
                <div className="me-auto">
                  <h3 className="page-title mb-5 pb-2">Cities</h3>
                </div>
              </div>
            </div>
            {/* Content Header (Page header) */}

            {/* Main content */}
            <section className="content">
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="box">
                    <div className="box-header with-border">
                      <h4 className="box-title">Cities List</h4>
                     <a
                        href={`${config.baseUrl}Addcity`}
                        className="btn btn-sm btn-primary add_btn"
                      >
                        Add
                      </a> 
                    </div>
                    <div className="box-body">
                    {CSVData.length >0 ?
                      <CSVLink data={CSVData} > <button className="btn-sm btn-primary"> Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i></button> <br /><br /></CSVLink>
                    : ""
                    }                      
                      <ReactDatatable
                        config={configForTable}
                        records={getcitylist}
                        columns={columns}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* /.content */}
            {/* /.content */}
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};
export default Cities;
